<template>
  <div v-wechat-title="title" style="height:100%">
    {{title}}
  </div>
</template>
<script>
export default {
    name: `AdverseEvent`,
    props: {

    },
    data() {
        return {
            title: `不良事件`
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AdverseEvent/Index.vue